import { PageContainer } from "src/components/organisms/contents";
import { ReactComponent as IconLeftArrow } from "../../styles/assets/svg/icon_LeftChevron.svg";
import { ReactComponent as IconRightArrow } from "../../styles/assets/svg/icon_RightChevron.svg";
import { ReactComponent as IconPill02 } from "../../styles/assets/svg/icon_pill02.svg";
import { ReactComponent as IconNoPill } from "../../styles/assets/svg/icon_pill_empty.svg";
import { ReactComponent as IconBellOn } from "../../styles/assets/svg/icon_bell_on.svg";
import { ReactComponent as IconBellOff } from "../../styles/assets/svg/icon_bell_off.svg";
import { FallbackImage } from "../diet/DietPage";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { ModalDatePicker } from "src/components/molecules/ModalDatePicker";
import { Buttons } from "src/components/atoms/Buttons";
import {
  formatTimeForPayload,
  formatToAmPm,
} from "src/common/hooks/userTimeFormat";
import Toast from "../myInfo/components/InfoToast";
import { useViewport } from "src/common/hooks/ViewPort";
import {
  useCreateHistory,
  useDeleteHistory,
  useHistoryRegister,
  useMedRegister,
  useUpdateHistory,
} from "src/common/hooks/usePillRegister";
import { confirmDialog } from "src/components/containers/ConfirmDialog";
import { ModalTakeTime } from "src/components/molecules/ModalTakeTime";
import { TopBackground } from "src/components/atoms/TopBackground/TopBackground";
import {
  ConHeader,
  titleText,
} from "src/components/atoms/MainHeaderBox/MainConHeader";
import { ScrollContainer } from "../report/HealthReportPage";
import { PopupEmotion } from "src/components/atoms/PopupEmotion";

const pillDay = ["전체", "아침", "점심", "저녁", "자기 전"];

export const PillPage = () => {
  const navi = useNavigate();
  const location = useLocation() as {
    state?: { toast?: string; date?: string };
  };
  const { px } = useViewport();

  const today = dayjs().format("YYYY.MM.DD");

  const [open, setOpen] = useState<boolean>(false); // 복약 ㅋㅋ기록 페이지 이동
  const [selectedDate, setSelectedDate] = useState<string>(today); // 날짜 선택 상태
  const [openCalendar, setOpenCalendar] = useState<boolean>(false); // 날짜 선택 모달 상태
  const [openTime, setOpenTime] = useState<boolean>(false); // 날짜 선택 모달 상태
  const [toast, setToast] = useState<string | null>(null); // toast 저장
  const formattedDate = selectedDate.split(".").join("");
  const [isActive, setIsActive] = useState<string | null>("전체"); // 복약 상태 관리
  const [selectedItem, setSelectedItem] = useState<any | null>(null); // 등록한 약 selected
  const [selectedTime, setSelectedTime] = useState<any | null>(null); // 등록한 약 시간 selected
  const [selectedHistory, setSelectedHistory] = useState<any | null>(null); // 등록한 약 selected
  const [completMedi, setCompletMedi] = useState<boolean>(false); // 복용 완료 팝업창

  /* 복약 기록 가져오기 */
  const { data: pillData = [] } = useMedRegister(formattedDate);

  /* 복용 하기 */
  const { mutateAsync: createHistory } = useCreateHistory();

  /* 복용 시간 수정 */
  const { mutateAsync: updateHistory } = useUpdateHistory({
    oid: selectedHistory,
  });

  /* 복용 취소하기 */
  const { mutateAsync: deleteHistory } = useDeleteHistory({
    oid: selectedHistory,
  });

  const scheduleOid = pillData.map((item) => item.oid);

  /* 히스토리 가져오기 */
  const { data: historyData = [], refetch } = useHistoryRegister(scheduleOid);

  /* 요일 바인딩 포맷 */
  const formattedDaysOfWeek = (days: string[]) => {
    if (days.length > 6) return "매일";
    else return days;
  };

  const formatTime = (h: string, m: string, d: string) =>
    `${d} ${String(h).padStart(2, "0")} : ${String(m).padStart(2, "0")}`;

  useEffect(() => {
    if (location.state?.toast) {
      setToast(location.state.toast);
      navi(".", { replace: true, state: {} });
    }
    if (location.state?.date) {
      setSelectedDate(dayjs(location.state.date!).format("YYYY.MM.DD"));
      navi(".", { replace: true, state: {} });
    }
  }, [location.state, navi]);

  useEffect(() => {
    if (completMedi) {
      const timer = setTimeout(() => {
        setCompletMedi(false);
      }, 1000); // 1000ms = 1초

      return () => clearTimeout(timer); // cleanup
    }
  }, [completMedi]);

  const handlePrev = () => {
    setSelectedDate((prev) =>
      dayjs(prev.replace(/\./g, "-")).subtract(1, "day").format("YYYY.MM.DD")
    );
  };

  const handleNext = () => {
    setSelectedDate((prev) =>
      dayjs(prev.replace(/\./g, "-")).add(1, "day").format("YYYY.MM.DD")
    );
  };

  // const toggleBell = (oid: string) => {
  //   setBellActive((prev) =>
  //     prev.includes(oid) ? prev.filter((i) => i !== oid) : [...prev, oid]
  //   );
  // };

  const formatDate = (y: number, m: number, d: number) =>
    `${y}.${String(m).padStart(2, "0")}.${String(d).padStart(2, "0")}`;

  // date에 복약 시간이 있는지 확인
  const hasMissingData = pillData.every(
    (item) => !item.timeList || !item.daysOfWeek || !item.filtered
  );

  /* 복용하기 */
  const handleSaveHistory = async (item: any, time: string) => {
    const payload = {
      dose: item.dose,
      doseUnit: item.doseUnit,
      scheduleOid: item.oid,
      mediTime: time,
      takeTime:
        today === selectedDate ? undefined : `${selectedDate} ${time}:00`,
    };
    await createHistory(payload);
    refetch();
  };

  /* 복용 시간 수정 */
  const handleUpdateHistory = async (data: string) => {
    const payload = {
      takeTime: `${dayjs(selectedDate.replace(/\./g, "-")).format(
        "YYYY-MM-DD"
      )} ${data}`,
    };
    await updateHistory(payload);
    refetch();
  };

  /* 복용 시간 삭제 */
  const handleDeleteHistory = async () => {
    const isConfirm = await confirmDialog({
      text: `복용을 취소 하시겠습니까?`,
      title: "복용 취소",
      options: {
        trueButtonText: "취소하기",
        falseButtonText: "돌아가기",
      },
    });
    if (isConfirm) {
      await deleteHistory();
      refetch();
      setOpen(false);
    }
  };

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 상단 배경 */}
        <TopBackground />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            position: "relative",
            zIndex: 1,
            paddingBottom: "70px",
          }}
        >
          {/* 헤더 */}
          <ConHeader title="복약" onClickArrow={() => navi("/")} />

          {/* 날짜 선택 */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: 48,
              zIndex: 1,
              padding: 8,
              background: "var(--white, white)",
              boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
              borderRadius: 999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 8px",
              }}
            >
              <IconLeftArrow
                style={{ cursor: "pointer" }}
                onClick={handlePrev}
              />
              <div
                style={{ ...titleText, fontWeight: 700, cursor: "pointer" }}
                onClick={() => setOpenCalendar(true)}
              >
                {selectedDate}
              </div>
              <IconRightArrow
                style={{ cursor: "pointer" }}
                onClick={handleNext}
              />
            </div>
            {/* 모달 */}
            {openCalendar && (
              <ModalDatePicker
                data={selectedDate}
                title="날짜"
                onClose={() => setOpenCalendar(false)}
                onConfirm={(year, month, day) => {
                  setSelectedDate(formatDate(year, month, day));
                  setOpenCalendar(false);
                }}
              />
            )}
          </div>

          {/* 오늘의 복약 기록 */}
          <div
            style={{
              width: "100%",
              padding: 16,
              background: "white",
              boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
              borderRadius: 16,
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            <div style={titleText}>오늘 먹을 약</div>

            {/* 복약 시간 카테고리 */}
            <ScrollContainer>
              <div
                style={{
                  width: "max-content",
                  display: "grid",
                  gridTemplateColumns: "repeat(5, 1fr)",
                  gap: 8,
                }}
              >
                {pillDay.map((pillDay) => {
                  const active = isActive === pillDay;
                  return (
                    <div
                      key={pillDay}
                      onClick={() => {
                        setIsActive(pillDay);
                      }}
                      style={{
                        width: "100%",
                        height: "32px",
                        background: active
                          ? "var(--neutral-700, #404040)"
                          : "var(--neutral-100, #F5F5F5)",
                        borderRadius: 50,
                        padding: "6px 12px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 10,
                        display: "flex",
                        transition:
                          "background-color 0.3s ease, color 0.3s ease",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          color: active
                            ? "white"
                            : "var(--neutral-700, #404040)",
                          fontSize: 16,
                          fontWeight: "500",
                          lineHeight: "24px",
                        }}
                      >
                        {pillDay}
                      </div>
                    </div>
                  );
                })}
              </div>
            </ScrollContainer>

            {/* 복약 등록 유무 */}
            {pillData.length > 0 && hasMissingData ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginTop: 8,
                }}
              >
                <IconPill02 />
                <span
                  style={{
                    textAlign: "center",
                    fontSize: "16px",
                    fontWeight: 700,
                    lineHeight: "24px",
                  }}
                >
                  먹을 약이 없어요.
                </span>
              </div>
            ) : (
              <>
                {pillData.length > 0 ? (
                  pillData?.map((item, idx) => (
                    <>
                      {item.daysOfWeek &&
                        item.timeList &&
                        item.filtered === true && (
                          <>
                            {item.timeList
                              .filter((time: string) => {
                                if (isActive === "전체") return true;

                                const hour = Number(time.split(":")[0]);
                                if (isActive === "아침")
                                  return hour >= 5 && hour <= 10;
                                if (isActive === "점심")
                                  return hour >= 11 && hour <= 14;
                                if (isActive === "저녁")
                                  return hour >= 15 && hour <= 20;
                                if (isActive === "자기 전")
                                  return hour >= 21 || hour <= 4;

                                return true;
                              })
                              .map((time: string, timeIdx: number) => {
                                const uniqueIdx = `${idx}-${timeIdx}`;

                                const targetDay = dayjs(
                                  selectedDate.replace(/\./g, "-"),
                                  "YYYY-MM-DD",
                                  true
                                );
                                const takenRecord = historyData.find(
                                  (h) =>
                                    h.scheduleOid === item.oid &&
                                    h.mediTime === time &&
                                    dayjs(h.takeTime).isSame(targetDay, "day")
                                );
                                const isTaken = !!takenRecord;
                                const ftTakeTime = new Date(
                                  takenRecord?.takeTime
                                );
                                const formattedTime = `${String(
                                  ftTakeTime.getHours()
                                ).padStart(2, "0")}:${String(
                                  ftTakeTime.getMinutes()
                                ).padStart(2, "0")}`;
                                return (
                                  <div
                                    key={uniqueIdx}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      background: "white",
                                      borderRadius: 16,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {}}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 12,
                                      }}
                                    >
                                      {item.fileUrl === null ? (
                                        ""
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: 48,
                                            height: 48,
                                            position: "relative",
                                            borderRadius: 16,
                                            overflow: "hidden",
                                            background:
                                              "var(--neutral-100, #F5F5F5)",
                                          }}
                                        >
                                          {item.fileUrl ? (
                                            <FallbackImage
                                              src={
                                                process.env.REACT_APP_API_FILE +
                                                item.fileUrl
                                              }
                                              alt={item.mediName}
                                            />
                                          ) : (
                                            <IconNoPill />
                                          )}
                                        </div>
                                      )}

                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            style={{
                                              ...titleText,
                                              color: isTaken ? "#a3a3a3" : "",
                                              textDecoration: isTaken
                                                ? "line-through"
                                                : "none",
                                            }}
                                          >
                                            {item.mediName}
                                          </div>
                                        </div>
                                        <div
                                          style={{
                                            color: "#A3A3A3",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            lineHeight: "20px",
                                            textDecoration: isTaken
                                              ? "line-through"
                                              : "none",
                                          }}
                                        >
                                          {`${formattedDaysOfWeek(
                                            item.daysOfWeek
                                          )} · ${formatToAmPm(time)}`}
                                        </div>
                                      </div>
                                    </div>

                                    {isTaken ? (
                                      <div
                                        style={{
                                          color: "#A3A3A3",
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          lineHeight: "20px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setSelectedItem(item);
                                          setSelectedTime(formattedTime);
                                          setSelectedHistory(takenRecord.oid);
                                          setOpen(true);
                                        }}
                                      >
                                        {formattedTime}
                                      </div>
                                    ) : (
                                      <>
                                        {item.daysOfWeek && time && (
                                          <Buttons
                                            size="sm"
                                            layout="defaultGradient"
                                            type="button"
                                            label="복용했어요"
                                            onClick={() => {
                                              setCompletMedi(true);
                                              handleSaveHistory(item, time);
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                          </>
                        )}
                    </>
                  ))
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <IconPill02 />
                      <span
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          fontWeight: 700,
                          lineHeight: "24px",
                        }}
                      >
                        추가된 약이 없어요 <br />
                        먹는 약을 추가해주세요.
                      </span>
                    </div>
                    <Buttons
                      size="lg-br"
                      layout="defaultGradient"
                      type="button"
                      label="+ 약 추가하기"
                      onClick={() => navi("/pill/write")}
                    />
                  </>
                )}
              </>
            )}
          </div>

          {/* 등록한 약 */}
          {pillData.length > 0 && (
            <div
              style={{
                width: "100%",
                padding: 16,
                background: "white",
                boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
                borderRadius: 16,
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <div style={titleText}>등록한 약</div>

              {/* 복약 등록 유무 */}
              <>
                {pillData?.map((item, idx) => (
                  <>
                    <div
                      key={item.oid}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "white",
                        borderRadius: 16,
                        cursor: "pointer",
                      }}
                      onClick={() => {}}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        {item.fileUrl === null ? (
                          ""
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: 48,
                              height: 48,
                              position: "relative",
                              borderRadius: 16,
                              overflow: "hidden",
                              background: "var(--neutral-100, #F5F5F5)",
                            }}
                          >
                            {item.fileUrl ? (
                              <FallbackImage
                                src={
                                  process.env.REACT_APP_API_FILE + item.fileUrl
                                }
                                alt={item.mediName}
                              />
                            ) : (
                              <IconNoPill />
                            )}
                          </div>
                        )}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                ...titleText,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {item.mediName}
                              <span
                                style={{
                                  color: "#A3A3A3",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  lineHeight: "20px",
                                  marginLeft: "8px",
                                }}
                              >
                                {`${item.dose || ""}${item.doseUnit || ""}`}
                              </span>
                            </div>
                          </div>
                          <div
                            style={{
                              color: "#A3A3A3",
                              fontSize: "14px",
                              fontWeight: 500,
                              lineHeight: "20px",
                            }}
                          >
                            {`${item.intakeTiming || ""} ${
                              (item.intakeTiming && "·") || ""
                            } ${formattedDaysOfWeek(item.daysOfWeek)} · ${
                              item.timesPerDay
                            }회`}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        {item.alarmYn === true ? (
                          <IconBellOn /* onClick={() => toggleBell(item.oid)} */
                          />
                        ) : (
                          <IconBellOff /* onClick={() => toggleBell(item.oid)} */
                          />
                        )}

                        <Buttons
                          size="sm"
                          layout="outline"
                          type="button"
                          label="수정하기"
                          onClick={() => {
                            navi("/pill/write", {
                              state: { item, date: formattedDate },
                            });
                          }}
                        />
                      </div>
                    </div>
                  </>
                ))}
                <Buttons
                  size="lg-br"
                  layout="ghost"
                  type="button"
                  label="+ 약 추가하기"
                  onClick={() =>
                    navi("/pill/write", { state: { date: formattedDate } })
                  }
                />
              </>
            </div>
          )}
        </div>

        {open && (
          <ModalTakeTime
            selectedItem={selectedItem}
            setOpen={setOpen}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            openTime={openTime}
            setOpenTime={setOpenTime}
            handleUpdateHistory={handleUpdateHistory}
            handleDeleteHistory={handleDeleteHistory}
          />
        )}
        {openTime && (
          <ModalDatePicker
            data={formatToAmPm(selectedTime)}
            title="시간 변경"
            onClose={() => setOpenTime(false)}
            onConfirm={(year, month, day) => {
              const data = formatTimeForPayload(formatTime(year, month, day));
              setSelectedTime(data);
              setOpenTime(false);
              setOpen(true);
              handleUpdateHistory(data);
            }}
            time={true}
          />
        )}
        {completMedi && (
          <PopupEmotion title="복용 완료!" setClick={setCompletMedi} />
        )}
        <Toast
          message={toast ?? ""}
          open={!!toast}
          px={px}
          onClose={() => setToast(null)}
        />
      </>
    </PageContainer>
  );
};
